export const APP_CONSTANTS = {
  ROLES: {
    USER: 'user',
    SALES: 'sales',
    OWNER: 'owner',
    ADMIN: 'admin',
    AGENT: 'agent',
    DEVELOPER: 'developer',
    MARKETING_PARTNER: 'marketing_partner'
  },
  ROUTES: {
    ADMIN_DASHBOARD: '/admin/dashboard',
    DEVELOPER_DASHBOARD: '/developer/dashboard',
    AGENT_DASHBOARD: '/agent/dashboard',
    PROFILE: '/profile',
    REGISTER: '/register',
    FORGOT_PASSWORD: '/auth/forgot-password'
  }
}